var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"align-items-center d-flex justify-content-center",staticStyle:{"min-height":"25vh"}},[_c('i',{staticClass:"fa-circle-notch fa-spin fas fs-1 text-primary"})])
}]

export { render, staticRenderFns }